import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';

// Proto: people.Medical.
export default class Medical extends Fragment {
  declare [Type]: 'people/medical';

  @array('string')
  declare schools: StatefulArray<string>;
}
